import React from 'react';

import { Checkbox, Form } from 'semantic-ui-react';

class FormbuilderCheckbox extends React.Component {

    render() {
        const { checked, inputLabel, onChange, label, validation } = this.props;
        const required = validation && validation.required;

        return (
            <Form.Field>
                {
                    label &&
                    <div className={required ? "required field" : null}>
                        <label>
                            {label}
                        </label>
                    </div>
                }
                <Checkbox label={inputLabel}
                    checked={checked}
                    onChange={onChange} />
            </Form.Field>
        );
    }
}

export default FormbuilderCheckbox;